import { cx } from '@linaria/core';
import { useRef, useMemo } from 'react';
import { useUserIdentityState } from '@provider/user-identity';
import { triggerEventOnContainerClick, decodeHtmlEntities } from '@utils/common';
import { rootWrapperCls, wrapperCls, textWrapperCls, labelList, labelListElement, title, author } from './_card.style.js';
import { AddResourceToCourseBuilder } from './atoms/add-to-course-builder.js';
import { Overlay } from './atoms/overlay.js';
import { Thumbnail } from './atoms/thumbnail.js';
import { getLabelForCard } from './util.get-label.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ResourceCard(props) {
  const ref = useRef(null);
  const user = useUserIdentityState(state => state.user);
  const isLoggedIn = !!user;
  const resource = useMemo(() => props.context === "course-frontpages" ? {
    ...props.resource,
    // always open ressources in lightbox when accessing them from
    // the course frontpage
    target: "Lightbox"
  } : props.resource, [props.context, props.resource]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: ref,
      className: rootWrapperCls,
      onClick: evt => triggerEventOnContainerClick({
        ref,
        ignores: ["a", "button"],
        triggerSelector: "[data-resource-trigger='true']"
      }, evt),
      children: [/*#__PURE__*/jsx(CardContent, {
        context: props.context,
        resource: resource
      }), isLoggedIn && /*#__PURE__*/jsx(AddResourceToCourseBuilder, {
        resource: resource
      })]
    })
  );
}
function CardContent(props) {
  const label = getLabelForCard(props.resource);
  const metadata = props.resource.card?.metadata;
  return /*#__PURE__*/jsxs("section", {
    className: wrapperCls,
    children: [/*#__PURE__*/jsx(Thumbnail, {
      resource: props.resource
    }), /*#__PURE__*/jsxs("div", {
      className: textWrapperCls,
      children: [(label || metadata?.pageCount || metadata?.duration) && /*#__PURE__*/jsxs("ul", {
        className: labelList,
        children: [label && /*#__PURE__*/jsx("li", {
          className: labelListElement,
          children: label
        }), metadata?.pageCount && /*#__PURE__*/jsx("li", {
          className: labelListElement,
          children: metadata?.pageCount
        }), metadata?.duration && /*#__PURE__*/jsx("li", {
          className: labelListElement,
          children: metadata.duration
        })]
      }), /*#__PURE__*/jsx("h3", {
        className: cx(title, metadata?.author && "single-line"),
        children: props.resource.title
      }), metadata?.author && /*#__PURE__*/jsxs("p", {
        className: author,
        children: ["af ", decodeHtmlEntities(metadata.author)]
      })]
    }), /*#__PURE__*/jsx(Overlay, {
      resource: props.resource,
      onLinkClick: props.onLinkClick
    })]
  });
}

export { ResourceCard };
//# sourceMappingURL=_card.js.map
